module.exports = __webpack_public_path__ + "img/cancelamento_ajuda.a1e3fc02.jpg";